<template>
  <div
    v-if="registerSuccessShow == false"
    id="AddGeneralMember"
    class="well"
    style="padding: 0 1em"
  >
    <div class="course_title">註冊會員資料</div>

    <div class="form-group">
      <table class="table" style="width: auto; align: left">
        <tbody>
          <tr>
            <td colspan="4" align="left">
              <span style="color: #f00"
                ><span style="color: #f00">＊</span>為必填項目。</span
              >
            </td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>會員姓名</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.Name"
                placeholder="會員姓名"
                required
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>會員性別</td>
            <td>
              <div class="input-group-text">
                <input
                  type="radio"
                  checked
                  id="Man"
                  v-model="queryInfo.Sex"
                  value="1"
                  aria-label="Radio button for following text input"
                />男

                <input
                  type="radio"
                  id="Woman"
                  v-model="queryInfo.Sex"
                  value="2"
                  aria-label="Radio button for following text input"
                />女
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>生日</td>
            <td>
              <div>
                <b-input-group class="mb-3">
                  <b-form-input
                    id="queryInfo.Birth"
                    v-model="queryInfo.Birth"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    required
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="queryInfo.Birth"
                      button-only
                      right
                      locale="zh-tw"
                      aria-controls="example-input"
                      @context="onContext"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>身分證字號(帳號)</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.IdNo"
                placeholder="身分證字號"
                required
                @change="CheckIdNo(queryInfo.IdNo)"
              />
            </td>
            <td class="td_left">
              <div v-if="idCheckShow">
                <label class="bg-danger text-white rounded">
                  自動檢查帳號是否重複
                </label>
              </div>
              <div v-if="idCheckShow1 == 1">
                <label class="bg-info text-white rounded"> 檢查帳號OK </label>
              </div>
              <div v-if="idCheckShow1 == 2">
                <label class="bg-danger text-white rounded"> 帳號重複 </label>
              </div>
            </td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>連絡電話</td>
            <td>
              <input
                type="Number"
                class="form-control"
                v-model="queryInfo.PhoneNo1"
                placeholder="連絡電話"
                required
              />
            </td>
            <td><span class="red_star">範例(0412345678)</span></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>行動電話</td>
            <td>
              <input
                type="Number"
                class="form-control"
                v-model="queryInfo.PhoneNo2"
                placeholder="行動電話"
                pattern="/^-?\d+\.?\d*$/"
                onKeyPress="if(this.value.length==10) return false;"
                required
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>電子信箱(認證信箱)</td>
            <td>
              <input
                type="email"
                class="form-control"
                v-model="queryInfo.EMail"
                placeholder="電子信箱"
                required
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>密碼</td>
            <td>
              <input
                type="password"
                class="form-control"
                v-model="queryInfo.PsWord"
                placeholder="密碼"
                minlength="8"
                required
              />
            </td>
            <td><span class="red_star">英文數字至少8碼以上</span></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>確認密碼</td>
            <td>
              <input
                type="password"
                class="form-control"
                ref="PsWord2"
                v-model="PsWord2"
                placeholder="確認密碼"
                minlength="8"
                required
                @change="chkPasswd()"
              />
            </td>
            <td><span class="red_star">英文數字至少8碼以上</span></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>交通工具</td>
            <td>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="0"
                  id="inlineCheckbox0"
                />
                <label class="form-check-label" for="0">公車</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="1"
                  id="inlineCheckbox1"
                />
                <label class="form-check-label" for="1">機車</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="2"
                  id="inlineCheckbox2"
                />
                <label class="form-check-label" for="2">汽車</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="3"
                  id="inlineCheckbox3"
                />
                <label class="form-check-label" for="3">步行</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="queryInfo.TransportationArray"
                  value="4"
                  id="inlineCheckbox4"
                />
                <label class="form-check-label" for="4">其他</label>
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>車牌號碼(步行、公車不需填寫)</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.PlateNumber"
                placeholder="車牌號碼(步行、公車不需填寫)"
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>飲食習慣</td>
            <td>
              <div class="input-group-text">
                <input
                  type="radio"
                  id="EatingHabits"
                  value="0"
                  checked
                  v-model="queryInfo.EatingHabits"
                  aria-label="Radio button for following text input"
                />葷

                <input
                  type="radio"
                  id="EatingHabits"
                  value="1"
                  v-model="queryInfo.EatingHabits"
                  aria-label="Radio button for following text input"
                />素
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span class="red_star">＊</span>優惠身分</td>
            <td>
              <div class="input-group-text">
                <input
                  type="radio"
                  id="Offer"
                  value="0"
                  @click="mode = false"
                  checked
                  v-model="queryInfo.Offer"
                  aria-label="Radio button for following text input"
                />無

                <input
                  type="radio"
                  id="Offer"
                  value="1"
                  @click="mode = true"
                  v-model="queryInfo.Offer"
                  aria-label="Radio button for following text input"
                />本校教職員工及親友（含退休）(9折)
              </div>
            </td>
            <td>
              <div v-if="mode">
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"

                  v-model="file[0]"
                  @input="fileChange()"
                  placeholder="上傳本校教職員證件或退休證件或親友證明"
                  accept="image/jpeg, image/png, image/gif, application/pdf"
                ></b-form-file>
              </div>
              <div v-else></div>
            </td>
            <td></td>
          </tr>
          <tr align="left">
            <td>服務單位/就讀學校</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.ServiceUnit"
                placeholder="服務單位/就讀學校"
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>聯絡地址</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.MailAddress"
                placeholder="聯絡地址"
              />
            </td>
            <td></td>
            <td></td>
          </tr>

          <tr align="left">
            <td><span class="red_star">＊</span>驗證碼</td>
            <td>
              <input
                type="text"
                class="form-control"
                ref="VerifyCode"
                v-model="VerifyCode"
                placeholder="驗證碼"
                required
                @change="chkVerifyCode()"
              />
            </td>
            <td>
              <img
                v-if="captchaInfo != null"
                :src="captchaInfo"
                style="margin: 0 0 0 0; height: 2.25em"
                alt=""
              />
              <a
                href="#"
                style="padding: 5px 0.6em"
                title="重新產生驗證碼"
                @click.prevent="getCaptcha()"
              >
                <b-icon icon="bootstrap-reboot"></b-icon
              ></a>
            </td>
            <td></td>
          </tr>

          <tr align="left">

            <td colspan="4">
               <span class="red_star">＊</span>
              <input
                type="checkbox"
                v-model="queryInfo.Agree"
                value="1"
                aria-label="Checkbox for following text input"
                required
              />

              我已閱讀並接受
              <a @click="agree()" ref="#"
                >【 <u>個人資料保護同意書</u> 】內容。</a
              >
            </td>
          </tr>
          <tr align="left">
            <td>訂閱電子報</td>
            <td>
              <input
                type="checkbox"
                v-model="queryInfo.EPaper"
                aria-label="Checkbox for following text input"
                required
              />訂閱
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr style="text-align: center">
            <td></td>
            <td>

            </td>
            <td>
              <button
                class="btn active bg-info text-white rounded"
                @click="addMember()"
              >
                送出資料
              </button>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal ref="q-modal" hide-footer title="個人資料保護同意書">
      <div class="card">
        <div class="card-body">
          <p class="card-text">
            親愛的學員您好：<br />

            　國立國立科技大學產學營運處為落實個人資料之保護，依照個人資料保護法第8條規定進行蒐集前之告知，若您未滿二十歲，應於您的法定代理人閱讀、瞭解並同意本同意書之所有內容及其後修改變更規定後，方得使用本服務，
            但若您已接受本服務，視為您已取得法定代理人之同意，並遵守以下所有規範：<br /><br />
            1.蒐集之目的：統計學生報名人數及其他合於教育部需要之業務。<br />
            2.蒐集之個人資料類別：包含姓名、性別、身份證字號、生日、學校或服務單位、電話、地址、車牌
            　連絡人資料。<br />
            3.個人資料利用之期間、地區、對象及方式：　<br />
            　(1) 期間：依照教育部所規範之資料保留年限。<br />
            　(2)
            地區：您的個人資料將用於本處業務所需之機關團體(如：保險公司)。<br />
            　(3)
            對象及方式：您的個人資料將提供保險公司辦理保險並由本處管理。<br />
            4.個人資料之權利：您可依個人資料保護法第3條規定，來電04-23924505#2471行使相關權力。<br />
            5.若您不願意提供真實且正確完整的個人資料，將可能導致無法成功報名此次活動。<br /><br />
            　如果您同意以上條款，再開始進行報名動作，如果不同意，也可請您親自至本處進行報名
            (報名完畢後，代表您已閱畢本次活動報名之個資告知事項，並同意本處處理及利用您的個人資料)<br /><br />
          </p>
        </div>
      </div>
    </b-modal>
  </div>
  <div v-else style="width: 30%">
    <h1>你已經成功完成註冊</h1>
    <h3>請進入你註冊的收件電子信箱啟用你的帳戶</h3>
  </div>
</template>

<script>
import * as tools from '../tool'

export default {
  name: 'AddGeneralMember',
  data () {
    return {
      mode: 0,
      file: [],
      fileList: [],
      registerSuccessShow: 0,
      idCheckShow1: 0,
      idCheckShow: true,
      total: 0,
      isIE: false,
      inputData: null,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      captchaInfoArray: {
        text1: '',
        text2: '',
        text3: ''
      },
      PsWord2: null,
      VerifyCode: null,
      captchaInfo: '',
      checkIdNo: '',
      attributesClassID: '', // 1:現職人才培育課程/2:專業證照課程/3:創客基地課程
      queryInfo: {
        sysId: 0,
        Name: '',
        Sex: '',
        Birth: '',
        IdNo: '',
        EMail: '',
        PsWord: '',
        PhoneNo1: '',
        PhoneNo2: '',
        MailAddress: '',
        Agree: '',
        ServiceUnit: '',
        TransportationArray: [],
        PlateNumber: '',
        EatingHabits: 0,
        EPaper: '',
        Offer: 0,
        Info: [],
        Receipt: 0
      }
    }
  },
  computed: {
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  methods: {
    isEmpty (data) {
      return !(data != null && data != undefined && data.length > 0)
    },
    checkSaveData () {
      var msg = ''

      if (this.isEmpty(this.queryInfo.Name)) {
        msg = '請輸入會員姓名'
      } else if (this.isEmpty(this.queryInfo.Sex)) {
        msg = '請輸入性別'
      } else if (this.isEmpty(this.queryInfo.Birth)) {
        msg = '請輸入生日'
      } else if (this.isEmpty(this.queryInfo.IdNo)) {
        msg = '請輸入身分證字號(帳號)'
      } else if (this.isEmpty(this.queryInfo.PhoneNo1)) {
        msg = '請輸入連絡人電話'
      } else if (this.isEmpty(this.queryInfo.PhoneNo2)) {
        msg = '請輸入連絡人行動電話'
      } else if (this.isEmpty(this.queryInfo.EMail)) {
        msg = '請輸入連絡人電子信箱(認證信箱)'
      } else if (this.isEmpty(this.queryInfo.PsWord)) {
        msg = '請輸入密碼'
      } else if (this.isEmpty(this.PsWord2)) {
        msg = '請輸入確認密碼'
      } else if (this.isEmpty(this.queryInfo.TransportationArray)) {
        msg = '請輸入交通工具'
      } else if (this.mode == 1 && this.isEmpty(this.file[0].name)) {
        msg = '請上傳優惠身分證明'
      } else if (this.isEmpty(this.VerifyCode)) {
        msg = '請輸入驗證碼'
      } else if (this.queryInfo.Agree == '') {
        msg = '請確定個人資料保護同意書'
      }
      return msg
    },
    clearFiles () {
      this.fileList = [null, null]
      this.$refs['file-input'].reset()
    },
    fileChange (e) {
      var vm = this
      this.formData = new FormData()
      this.formData.append('header', this.file[0])

      this.$http
        .post('./WebApi/Common/UploadV2', this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            vm.queryInfo.Info.push(response.data[0])
          } else {
            tools.showAlert(vm, 'danger', '上傳檔案失敗' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    },
    onContext (ctx) {
      this.queryInfo.Birth = ctx.selectedYMD // Selected: '2022-02-22'
    },
    addMember: function () {
      var msg = this.checkSaveData()
      if (msg.length != 0) {
        alert(msg)
        return null
      }

      const vm = this

      this.$http
        .put('./WebApi/ociaRep/SetociaRepGeneralMember/', this.queryInfo)
        .then((response) => {
          if (response.data > 0) {
            vm.registerSuccessShow = true
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    chkVerifyCode () {
      var vm = this
      if (vm.VerifyCode != vm.captchaInfoArray.text1) {
        tools.showAlert(vm, 'danger', '對不起,請確認驗證碼是否正確')
        vm.$refs.VerifyCode.focus()
      }

      return null
    },
    chkPasswd () {
      var vm = this
      if (vm.queryInfo.PsWord != vm.PsWord2) {
        tools.showAlert(vm, 'danger', '對不起,請確認密碼是否正確')
        vm.$refs.PsWord2.focus()
      }
      if (vm.queryInfo.PsWord.length < 8 || vm.PsWord2.length < 8) {
        tools.showAlert(vm, 'danger', '對不起,請確認密碼長度是否小於8')
        vm.$refs.PsWord2.focus()
      }

      return null
    },
    agree () {
      this.$refs['q-modal'].show()
    },
    getCaptcha: function () {
      var vm = this
      this.$http
        .get('./WebApi/Common/GetCaptcha/')
        .then(function (response) {
          vm.captchaInfoArray = response.data
          vm.captchaInfo = vm.captchaInfoArray.text2
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    CheckIdNo: function (IdNo) {
      var vm = this
      this.$http
        .get('./WebApi/ociaRep/GetociaRepCheckIdNo/'.concat(IdNo))
        .then(function (response) {
          if (response.data == 1) {
            tools.showAlert(vm, 'danger', '對不起,帳號已經註冊過了')
            vm.idCheckShow1 = 2
            vm.idCheckShow = false
            return 0
          } else {
            vm.idCheckShow1 = 1
            vm.idCheckShow = false
            return 1
            // tools.showAlert(vm, "success", "恭喜你,帳號沒有註冊過");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    }
  },
  created () {
    console.log('======created View =====')
    this.isIE =
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1 ||
      navigator.userAgent.indexOf('Edge') > -1

    this.attributesClassID = this.$route.query.attributesClassID
    if (this.attributesClassID == 0) this.attributesClassID = ''

    const vm = this

    this.getCaptcha()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
